const initialState = {
    apis: {},
    overlays: {},
};

export default initialState;
